

































import Row from '@/views/molecules/Row.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import FromTo from '@/views/molecules/FromTo.vue'
import WeekToggle from '@/views/molecules/WeekToggle.vue'
import GreenButton from '@/views/atoms/GreenButton.vue'
import PartnerCode from '@/views/atoms/PartnerCode.vue'
import TextDatePicker from '@/views/molecules/NoStoreTextDatePicker.vue'
import store from '@/store'
import BlueButton from '@/views/atoms/BlueButton.vue'

export default
  components: {
    Row
    TextBox
    FromTo
    WeekToggle
    GreenButton
    PartnerCode
    TextDatePicker
    BlueButton
  }

  data: () ->
    selectedIndex: 2
    param: {}

  methods: {
    save_click: () ->
      postParam = 
        ship_name: @param.ship_name
        booking: @param.booking
        loading_area: @param.loading_area
        landing_area: @param.landing_area
        departure_date_plan_from: @param.departure_date_plan_from
        departure_date_plan_to: @param.departure_date_plan_to
      @$emit('click', postParam)
    select_toggle: (e, index) ->
      @selectedIndex = index
      @.$set(@param, 'departure_date_plan_from', e[0])
      @.$set(@param, 'departure_date_plan_to', e[1])
      # コンポーネントへの反映を待つ
      obj = @
      setTimeout(() ->
        obj.save_click()
      , 100)
    clear_click: () ->
      @selectedIndex = 2
      store.dispatch('initPostParam')
      for i, r of @param
        @.$set(@param, i, '')
      @$emit('clear', @param)
    change: (v) ->
      @.$set(@param, v.name, v.val)
    departureDatePlanFrom: (v) ->
      @.$set(@param, 'departure_date_plan_from', v.val)
    departureDatePlanTo: (v) ->
      @.$set(@param, 'departure_date_plan_to', v.val)
  }
